var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_281)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5094,
    y: 8.43311,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "#17065A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7071 53.9287C46.9173 53.9287 56.0049 44.8411 56.0049 33.6309C56.0049 22.4208 46.9173 13.3331 35.7071 13.3331C24.4969 13.3331 15.4093 22.4208 15.4093 33.6309C15.4093 44.8411 24.4969 53.9287 35.7071 53.9287Z",
    fill: "#17065A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0211 28.5843C28.8588 28.3829 28.6126 28.271 28.3497 28.271H22.9284C22.8836 28.271 22.8444 28.2542 22.8109 28.2262C22.7829 28.1982 22.7661 28.1647 22.7661 28.1255V24.4721C22.7661 24.4329 22.7829 24.3994 22.8109 24.3714C22.8444 24.3378 22.8836 24.3211 22.9284 24.3266H28.6574C30.1008 24.3266 31.3485 24.9197 32.4003 26.1002L33.7934 27.801L31.0799 31.1075L29.0211 28.5843ZM39.0357 26.0834C40.0819 24.9141 41.3351 24.3266 42.7954 24.3266H48.5076C48.5468 24.3211 48.586 24.3378 48.6139 24.3602C48.6419 24.3882 48.6531 24.4274 48.6475 24.4721V28.1255C48.6475 28.1647 48.6363 28.1982 48.6139 28.2262C48.586 28.2598 48.5468 28.2765 48.5076 28.271H43.0863C42.8289 28.2654 42.5828 28.3829 42.4149 28.5843L38.4203 33.4461L42.4317 38.3415C42.594 38.5262 42.8345 38.6381 43.0807 38.6325H48.502C48.5412 38.6269 48.586 38.6492 48.6083 38.6772C48.6307 38.7108 48.6475 38.7555 48.6419 38.7947V42.4481C48.6419 42.4873 48.6307 42.5208 48.6083 42.5488C48.5804 42.5824 48.5412 42.5991 48.502 42.5936H42.7954C41.3351 42.5936 40.0931 42.0005 39.0525 40.82L35.7292 36.7638L32.4059 40.82C31.3597 42.0005 30.1064 42.5936 28.6462 42.5936H22.9284C22.8892 42.5991 22.8444 42.5768 22.8221 42.5488C22.7941 42.5152 22.7829 42.4705 22.7885 42.4313V38.7779C22.7885 38.7388 22.7997 38.7052 22.8221 38.6772C22.85 38.6436 22.8892 38.6269 22.9284 38.6325H28.3497C28.607 38.6325 28.8532 38.515 29.0211 38.3192L32.943 33.53L39.0357 26.0834Z",
    fill: "#00D1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_281",
    x: 0.00939941,
    y: 0.733105,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_281"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.4093,
    y: 13.3331,
    width: 40.6,
    height: 40.6,
    rx: 20.3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnx);
export default __webpack_public_path__ + "static/media/snx.21493548355f3d26e64337f23b3c5090.svg";
export { ForwardRef as ReactComponent };